import {
    Component, ContentChild, OnChanges, SimpleChanges, SimpleChange
    , ViewEncapsulation, Input, Output, EventEmitter
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CriteriaAddComponent } from '../criteria/criteria.add.component';
import { SurveyDetails } from '../models/dto/survey';
import { CriteriaDetails } from '../models/dto/criteria';
import { CriteriaOptionDetails } from '../models/dto/criteria-options-details';
import { CriteriaService } from '../services/criteria.service';
import { JobService } from '../services/job.service';


@Component({
    selector: 'criteria-short-details',
    template: `<div class="bx-criteria-short text-left p-2">
                <a *ngIf="editMode" href="javascript:;" class="ln-critedit" [routerLink]="['/criteria/edit/', {id: criteria.id}]">
                    <span class="h4 p-2">{{ criteria.title }} </span>
                </a>
                <a *ngIf="editMode" href="javascript:;" class="ln-critedit" (click)="openDeleteModal(confirmDeleteModal)">
                    <span class="small del-icon ft-grey-light"><span class="oi oi-x"></span></span>
                </a>
                <span *ngIf="!editMode" class="h4 p-2">{{ criteria.title }} </span>
                <div>
                    <ng-template ngFor let-opt let-last=last [ngForOf]="criteriaOptions | orderBy:'importance'">
                    <div class='p-2' [ngClass]="(opt.importance == 1)? 'grey40 ft-wt500': (opt.importance == 2)? 'grey40': (opt.importance == 3)? 'ft-grey-light': (opt.importance == 4)? 'grey40':''">
                        <span *ngIf="opt.importance == 1"><span class="smile1"></span></span>
                        <span *ngIf="opt.importance == 2"><span class="smile2"></span></span>
                        <span *ngIf="opt.importance == 3"><span class="smile3"></span></span>
                        <span *ngIf="opt.importance == 4"><span class="smile4"></span></span>
                        <span [ngClass]="opt.importance == 4 ? 'text-stroke' : ''">{{ opt.title }}</span>
                    </div>
                    <div *ngIf="!last" class="hr-top"></div>
                    </ng-template>
                </div>
            </div>
            <ng-template #confirmDeleteModal let-c="close" let-d="dismiss">
            <div class="text-center">
                <button type="button" class="close" id="closeModalButton" [hidden]="true" (click)="c('Close click')"></button>
                <div class="modal-body">
                    Êtes-vous sûr de supprimer <strong>{{ criteria.title }}</strong> ?
                </div>
                <div class="p-4">
                    <input type="button" class="btn btn-success" (click)="deleteCriteria(criteria.id)" value="SUPPRIMER">
                </div>
            </div>
        </ng-template>
    `,
    styleUrls: ['./criteria.short.details.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CriteriaShortDetailsComponent implements OnChanges {

    @Input() criteria: CriteriaDetails;
    @Input() editMode = false;
    closeResult: string;
    criteriaOptions: Array<CriteriaOptionDetails> = [];

    constructor(private modalService: NgbModal, private criteriaService: CriteriaService, private jobService: JobService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.criteria && this.criteria) {
            this.criteria.options.forEach(opt => {
                this.criteriaOptions.push(opt);
            });
            // this.criteriaOptions = this.criteriaOptions.sort(x => x.importance);
        }
    }

    open(content) {
        this.modalService.open(content, { windowClass: 'confirm-delete' }).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }
    openDeleteModal(content) {
        this.modalService.open(content, { windowClass: 'confirm-delete' }).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    deleteCriteria(criteriaId) {
        const optionsIds: Array<string> = [];
        const answerIds: Array<string> = [];
        this.criteria.options.forEach(option => {
            optionsIds.push(option.id);
        });
        optionsIds.forEach(optId => {
            this.jobService.getOptionAnswers(optId).subscribe(data => {
                data.allAnswers.forEach(answer => {
                    answerIds.push(data.allAnswers.id);
                });
            });
        });
        if (optionsIds.length > 0) {
            if (answerIds.length > 0) {
                this.criteriaService.deleteAnswers(answerIds).subscribe(data => {
                });
            }
            this.criteriaService.deleteOptions(optionsIds).subscribe(data => {
                this.criteriaService.deleteCriteria(criteriaId).subscribe(resp => {
                    document.getElementById('closeModalButton').click();
                });
            });
        } else {
            this.criteriaService.deleteCriteria(criteriaId).subscribe(data => {
                document.getElementById('closeModalButton').click();
            });
        }
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/criteria/criteria.short.details.component.ts